import { Reducer } from "redux";

import { RequestAuthorizationResponse } from "../models/Api/RequestAuthorization";
import { RequestAuthorizationDispatchTypes } from "../constants/RequestAuthorization";
import { RequestAuthorizationActionDispatchTypes, RequestAuthorizationActionError, RequestAuthorizationActionSuccess } from "../models/DispatchTypes/RequestAuthorization";

const completeAuthorizationState = (
  state: RequestAuthorizationResponse,
  action: RequestAuthorizationActionSuccess | RequestAuthorizationActionError
): RequestAuthorizationResponse => ({
  ...state,
  error: null,
  response: action.response,
  loading: false,
});

const initialState: RequestAuthorizationResponse = {
  loading: false,
  response: {
    requestId: 0,
  },
  error: null,
};

const RequestAuthorizationReducer: Reducer<
  RequestAuthorizationResponse,
  RequestAuthorizationActionDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case RequestAuthorizationDispatchTypes.REQUEST_AUTHORIZATION_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case RequestAuthorizationDispatchTypes.REQUEST_AUTHORIZATION_SUCCESS: {
      return completeAuthorizationState(state, action);
    }
    case RequestAuthorizationDispatchTypes.REQUEST_AUTHORIZATION_ERROR: {
      return completeAuthorizationState(state, action);
    }
    case RequestAuthorizationDispatchTypes.REQUEST_AUTHORIZATION_RESET: {
      return initialState;
    }
  }
  return state;
};

export default RequestAuthorizationReducer;
